var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6078_4610",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7803 2.21967C16.4874 1.92678 16.0126 1.92678 15.7197 2.21967L11.7197 6.21967C11.6478 6.29158 11.5935 6.37445 11.5569 6.46291C11.5202 6.55134 11.5 6.64831 11.5 6.75C11.5 6.94194 11.5732 7.13388 11.7197 7.28033L15.7197 11.2803C16.0126 11.5732 16.4874 11.5732 16.7803 11.2803C17.0732 10.9874 17.0732 10.5126 16.7803 10.2197L14.0607 7.5H21.25C21.6642 7.5 22 7.16421 22 6.75C22 6.33579 21.6642 6 21.25 6H14.0607L16.7803 3.28033C17.0732 2.98744 17.0732 2.51256 16.7803 2.21967ZM8.5 20.5C11.2614 20.5 13.5 18.2614 13.5 15.5C13.5 12.7386 11.2614 10.5 8.5 10.5C5.73858 10.5 3.5 12.7386 3.5 15.5C3.5 18.2614 5.73858 20.5 8.5 20.5ZM15 15.5C15 19.0899 12.0899 22 8.5 22C4.91015 22 2 19.0899 2 15.5C2 11.9101 4.91015 9 8.5 9C12.0899 9 15 11.9101 15 15.5ZM8.5 10.85C8.91421 10.85 9.25 11.1858 9.25 11.6V15.1893L10.9803 16.9197C11.2732 17.2126 11.2732 17.6874 10.9803 17.9803C10.6874 18.2732 10.2126 18.2732 9.91967 17.9803L7.96967 16.0303C7.82902 15.8897 7.75 15.6989 7.75 15.5V11.6C7.75 11.1858 8.08579 10.85 8.5 10.85Z",
    fill: "#2B323B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6078_4610)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#2B323B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockChevronLeft);
export default __webpack_public_path__ + "static/media/clock-chevron-left.a5f650e93115197c0e2268e8b9594565.svg";
export { ForwardRef as ReactComponent };